// ============================================================
// CLIENTS — data-driven list used across the site
// ============================================================
// To ADD a client:
//   1. (Optional) Place their logo in public/assets/clients/
//      as a PNG or JPG. Use a short kebab-case filename, e.g.
//      new-customer.png. Aim for a transparent-background image
//      approximately 400x200 for best display.
//   2. Add an entry to the `clients` array below.
//   3. Save. The marquee and clients page pick it up automatically.
//
// To HIDE a client from the marquee, set `displayLogo: false`.
// To DEACTIVATE a client entirely, set `active: false`.
//
// If `logo` is null / not supplied, the client's name is
// rendered as a tasteful text plate — no fake logo is generated.
// ============================================================

export const clients = [
  {
    name: "IDEMIA SYSCOM",
    logo: "/assets/clients/idemia-syscom.jpg",
    website: "",
    industry: "Secure Identity & Digital Security",
    active: true,
    displayLogo: true,
  },
  {
    name: "Samvardhana Motherson",
    logo: "/assets/clients/samvardhana-motherson.png",
    website: "",
    industry: "Automotive Components",
    active: true,
    displayLogo: true,
  },
  {
    name: "Unicel Corporation Limited",
    logo: "/assets/clients/unicel-corporation.png",
    website: "",
    industry: "Manufacturing",
    active: true,
    displayLogo: true,
    // Unicel's supplied logo has extra whitespace — nudge it visually larger
    // so it reads at a similar weight to the other logos.
    logoScale: 1.5,
  },
  {
    name: "Thomson Press",
    logo: "/assets/clients/thomson-press.jpg",
    website: "",
    industry: "Print & Publishing",
    active: true,
    displayLogo: true,
  },
  {
    name: "IPSC Solutions Private Limited",
    logo: "/assets/clients/ipsc-solutions.jpg",
    website: "",
    industry: "End-to-End Solutions",
    active: true,
    displayLogo: true,
  },
  {
    name: "RCRS Innovations Limited",
    logo: "/assets/clients/rcrs-innovations.png",
    website: "",
    industry: "Innovations",
    active: true,
    displayLogo: true,
  },
  {
    name: "The Sports Factory International",
    logo: "/assets/clients/the-sports-factory.jpg",
    website: "",
    industry: "Sports Goods",
    active: true,
    displayLogo: true,
  },
  {
    name: "Indic House of Crafts",
    logo: null,
    website: "",
    industry: "Crafts & Lifestyle",
    active: true,
    displayLogo: false,
  },
];

export function activeClients() {
  return clients.filter((c) => c.active !== false);
}
export function clientsWithLogos() {
  return clients.filter((c) => c.active !== false && c.displayLogo && c.logo);
}
